export default __webpack_public_path__ + "/dist/images/b2b.1e791497aa8bfa9e7c8e46475655dde7.svg";